import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_collect",
  "use": "icon-icon_collect-usage",
  "viewBox": "0 0 18 17.969",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17.969\" id=\"icon-icon_collect\">\n  <defs>\n  </defs>\n  <path id=\"icon-icon_collect_收藏\" class=\"cls-1\" d=\"M656.411,847.9a0.9,0.9,0,0,1-1.3-.986l0.453-5.2-3.289-3.93a0.937,0.937,0,0,1,.5-1.594l4.869-1.157,2.556-4.487a0.87,0.87,0,0,1,1.605,0l2.556,4.487,4.869,1.157a0.936,0.936,0,0,1,.5,1.594l-3.289,3.93,0.455,5.2a0.894,0.894,0,0,1-1.3.985L661,845.838Zm0,0\" transform=\"translate(-652 -830.031)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol